// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35YWO","importantInfo":"styles_importantInfo__1WQ3h"};